import { adminHttpClient } from '../../../commons/adminHttpClient'

export type SetIchraRenewalWaitingPeriodRequest = {
  productClassId: string
  waitingPeriod: number
}

const setIchraRenewalWaitingPeriod = (payload: SetIchraRenewalWaitingPeriodRequest): Promise<void> => {
  return adminHttpClient.post(`/Benefit/BenefitRenewal/Ichra/SetRenewalWaitingPeriod`, payload)
}

export default setIchraRenewalWaitingPeriod
